import React from "react";
import why305 from "images/why305.png";
import Badge from "shared/Badge/Badge";

const WhyLevel305 = () => {
  return (
    <div className=" text-[#94A3B8] py-16 px-8 md:px-20">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Left Column: Text Section */}
        <div className="space-y-8">
          <h2 className="text-4xl font-bold text-[#E2E8F0] ">
            Why JoyRides Rentals
          </h2>

          {/* Feature 1: Diverse Fleet of Vehicles */}
          <Badge name="Fleet" />
          <div className="flex items-start space-x-4">
            <div>
              <span className="text-xl font-bold text-[#E2E8F0]">
                Extensive Selection
              </span>
              <p className="text-[#94A3B8] max-w-[80%]">
                Choose from a variety of luxury and performance vehicles so you
                can arrive in style for all occasions.
              </p>
            </div>
          </div>

          <Badge color="green" name="Value" />
          <div className="flex items-start space-x-4">
            <div>
              <h3 className="text-xl font-bold text-[#E2E8F0]">
                Unbeatable Rates
              </h3>
              <p className="text-[#94A3B8] max-w-[80%]">
                We offer transparent and competitive pricing with no hidden fees
                to ensure you get the best experience for the best price.
              </p>
            </div>
          </div>

          {/* Feature 3: Affordable Pricing */}
          <Badge color="red" name="Convenience" />
          <div className="flex items-start space-x-4">
            <div>
              <h3 className="text-xl font-bold text-[#E2E8F0]">
                Booking & Delivery
              </h3>
              <p className="text-[#94A3B8] max-w-[80%]">
                Get on the road faster with our seamless booking service. Pick
                up your keys at the airport, a custom address, or a free local
                pickup location via secure lockbox.
              </p>
            </div>
          </div>
          <Badge color="yellow" name="Service" />
          <div className="flex items-start space-x-4">
            <div>
              <h3 className="text-xl font-bold text-[#E2E8F0]">
                Exceptional Experience
              </h3>
              <p className="text-[#94A3B8] max-w-[80%]">
                Book with confidence knowing you'll receive a 5-star,
                personalized experience from start to finish. Each vehicle is
                impeccably detailed and inspected before every trip.
              </p>
            </div>
          </div>
        </div>

        {/* Right Column: Image Section */}
        <div className="relative">
          <img src={why305} alt="Luxury Car" className="object-cover" />
        </div>
      </div>
    </div>
  );
};

export default WhyLevel305;
